import React, { useState, Fragment } from 'react';
import { Box, Typography, Paper, TextField, Button, Grid, Card, CardContent, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Alert, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox, List, ListItem, ListItemButton, ListItemText, Divider } from '@mui/material';
import { Icon } from '@iconify/react';
import { Close as CloseIcon, Info as InfoIcon, CheckCircle as CheckCircleIcon, Error as ErrorIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { detectMTOsFromTransactionId } from '../../utils/constants';
interface TransactionData {
  id: string;
  mto: string;
  sender: {
    fullName: string;
    country: string;
    city: string;
    idType: string;
    idNumber: string;
    mobileNumber: string;
  };
  receiver: {
    fullName: string;
    country: string;
    city: string;
    mobileNumber: string;
    bankName: string;
    bankBranch: string;
    accountNumber: string;
  };
  transaction: {
    date: string;
    sendAmount: number;
    sendCurrency: string;
    exchangeRate: number;
    payoutAmount: number;
    payoutCurrency: string;
    purpose: string;
    relationship: string;
  };
  teller: {
    branchCode: string;
    branchName: string;
    paymentDate: string;
    tellerId: string;
    tellerName: string;
  };
}
interface InitiatedTransaction {
  id: string;
  cnic: string;
  fullName: string;
  fatherName: string;
  cnicExpiry: string;
  address: string;
  date: string;
  status: string;
}
const TransactionLookupPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchId, setSearchId] = useState('');
  const [transaction, setTransaction] = useState<TransactionData | null>(null);
  const [matchingTransactions, setMatchingTransactions] = useState<TransactionData[]>([]);
  const [showDetails, setShowDetails] = useState(false);
  const [showMTOSelection, setShowMTOSelection] = useState(false);
  const [idType, setIdType] = useState('CNIC');
  const [idNumber, setIdNumber] = useState('');
  const [receiverName, setReceiverName] = useState('');
  const [veresysBioSys, setVeresysBioSys] = useState(false);
  const [ofacUnscVerification, setOfacUnscVerification] = useState(false);
  const [contactNumber, setContactNumber] = useState('');
  const [country, setCountry] = useState('Pakistan');
  const [province, setProvince] = useState('');
  const [city, setCity] = useState('');
  const [idExpiry, setIdExpiry] = useState('');
  const [email, setEmail] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [address, setAddress] = useState('');
  const [error, setError] = useState('');
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showDuplicateDialog, setShowDuplicateDialog] = useState(false);
  const [initiatedTransactionId, setInitiatedTransactionId] = useState('');
  const partners = ['UAE Exchange', 'Al Ansari Exchange', 'Ria Money Transfer', 'Western Union', 'MoneyGram'];
  const provinces = ['Punjab', 'Sindh', 'Khyber Pakhtunkhwa', 'Balochistan', 'Gilgit-Baltistan', 'Azad Kashmir'];
  const citiesByProvince: Record<string, string[]> = {
    Punjab: ['Lahore', 'Faisalabad', 'Rawalpindi', 'Multan', 'Gujranwala', 'Sialkot', 'Bahawalpur', 'Sargodha', 'Sheikhupura', 'Jhang', 'Rahim Yar Khan', 'Gujrat', 'Kasur', 'Sahiwal', 'Okara'],
    Sindh: ['Karachi', 'Hyderabad', 'Sukkur', 'Larkana', 'Nawabshah', 'Mirpur Khas', 'Jacobabad', 'Shikarpur', 'Khairpur', 'Dadu'],
    'Khyber Pakhtunkhwa': ['Peshawar', 'Mardan', 'Abbottabad', 'Mingora', 'Kohat', 'Dera Ismail Khan', 'Bannu', 'Swabi', 'Charsadda', 'Nowshera'],
    Balochistan: ['Quetta', 'Turbat', 'Khuzdar', 'Hub', 'Gwadar', 'Chaman', 'Sibi', 'Loralai', 'Zhob', 'Dera Murad Jamali'],
    'Gilgit-Baltistan': ['Gilgit', 'Skardu', 'Hunza', 'Ghanche', 'Diamer', 'Astore', 'Ghizer'],
    'Azad Kashmir': ['Muzaffarabad', 'Mirpur', 'Rawalakot', 'Kotli', 'Bhimber', 'Bagh', 'Palandri']
  };
  const handleSearch = () => {
    // Check if transaction ID already exists in transaction history
    const existingTransactions = JSON.parse(localStorage.getItem('initiatedTransactions') || '[]');
    const isDuplicate = existingTransactions.some((t: any) => t.id === searchId);
    if (isDuplicate) {
      setInitiatedTransactionId(searchId);
      setShowDuplicateDialog(true);
      setError('');
      setTransaction(null);
      return;
    }
    // Demo transactions data with multiple MTOs for same ID
    const demoTransactions: TransactionData[] = [
    // 801234567 - Same ID for both Ecobank and Access to test MTO selection
    {
      id: '801234567',
      mto: 'Ecobank Transfer',
      sender: {
        fullName: 'Amara Diallo',
        country: 'Ghana',
        city: 'Accra',
        idType: 'Passport',
        idNumber: 'GH9876543',
        mobileNumber: '+233701234567'
      },
      receiver: {
        fullName: 'Abena Mensah',
        country: 'Nigeria',
        city: 'Lagos',
        mobileNumber: '+2348012345678',
        bankName: 'GTBank',
        bankBranch: 'Victoria Island Branch',
        accountNumber: 'NG0058GTBK00098765432'
      },
      transaction: {
        date: '2025-01-20',
        sendAmount: 1000,
        sendCurrency: 'USD',
        exchangeRate: 1550.0,
        payoutAmount: 1550000,
        payoutCurrency: 'NGN',
        purpose: 'Family Support',
        relationship: 'Sister'
      },
      teller: {
        branchCode: 'LOS-001',
        branchName: 'Lagos Main Branch',
        paymentDate: '2025-01-20',
        tellerId: 'TL002',
        tellerName: 'Sana Ahmed'
      }
    }, {
      id: '801234567',
      mto: 'Access Money Express',
      sender: {
        fullName: 'Kwame Asante',
        country: 'Kenya',
        city: 'Nairobi',
        idType: 'Passport',
        idNumber: 'KE1234567',
        mobileNumber: '+254701234567'
      },
      receiver: {
        fullName: 'Fatima Bello',
        country: 'Nigeria',
        city: 'Abuja',
        mobileNumber: '+2348001234567',
        bankName: 'Access Bank',
        bankBranch: 'Wuse Branch',
        accountNumber: 'NG044ACCB0001234567890'
      },
      transaction: {
        date: '2025-01-20',
        sendAmount: 1000,
        sendCurrency: 'USD',
        exchangeRate: 1550.0,
        payoutAmount: 1550000,
        payoutCurrency: 'NGN',
        purpose: 'Family Support',
        relationship: 'Brother'
      },
      teller: {
        branchCode: 'ABJ-001',
        branchName: 'Abuja Main Branch',
        paymentDate: '2025-01-20',
        tellerId: 'TL001',
        tellerName: 'Asad Khan'
      }
    },
    // Original demo transactions
    {
      id: 'TXN000001201921',
      mto: 'Access Money Express',
      sender: {
        fullName: 'Ahmed Al Mansouri',
        country: 'United Arab Emirates',
        city: 'Dubai',
        idType: 'Passport',
        idNumber: 'A1234567',
        mobileNumber: '+971501234567'
      },
      receiver: {
        fullName: 'Muhammad Ali',
        country: 'Nigeria',
        city: 'Lagos',
        mobileNumber: '+2348001234567',
        bankName: 'GTBank',
        bankBranch: 'Victoria Island Branch',
        accountNumber: 'NG0058GTBK00098765432'
      },
      transaction: {
        date: '2023-04-15',
        sendAmount: 5000,
        sendCurrency: 'AED',
        exchangeRate: 420.5,
        payoutAmount: 2102500,
        payoutCurrency: 'NGN',
        purpose: 'Family Support',
        relationship: 'Brother'
      },
      teller: {
        branchCode: 'LOS-001',
        branchName: 'Lagos Main Branch',
        paymentDate: '2023-04-15',
        tellerId: 'TL001',
        tellerName: 'Asad Khan'
      }
    }];
    // Find all matching transactions
    const matches = demoTransactions.filter(t => t.id === searchId);
    if (matches.length === 0) {
      setError('Transaction not found');
      setTransaction(null);
      setMatchingTransactions([]);
    } else if (matches.length === 1) {
      // Single match - show details directly
      setTransaction(matches[0]);
      setMatchingTransactions([]);
      setShowDetails(true);
      setError('');
      resetForm();
    } else {
      // Multiple matches - show MTO selection
      setMatchingTransactions(matches);
      setShowMTOSelection(true);
      setError('');
    }
  };
  const handleMTOSelection = (selectedTransaction: TransactionData) => {
    setTransaction(selectedTransaction);
    setMatchingTransactions([]);
    setShowMTOSelection(false);
    setShowDetails(true);
    resetForm();
  };
  const resetForm = () => {
    setIdType('CNIC');
    setIdNumber('');
    setReceiverName('');
    setVeresysBioSys(false);
    setOfacUnscVerification(false);
    setContactNumber('');
    setCountry('Pakistan');
    setProvince('');
    setCity('');
    setIdExpiry('');
    setEmail('');
    setDateOfBirth('');
    setZipCode('');
    setAddress('');
  };
  const validateAge = (dob: string): boolean => {
    const today = new Date();
    const birthDate = new Date(dob);
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || monthDiff === 0 && today.getDate() < birthDate.getDate()) {
      return age - 1 >= 18;
    }
    return age >= 18;
  };
  const handleInitiateTransaction = () => {
    console.log('Initiate Transaction button clicked'); // Debug log
    setError('');
    // Validate required fields
    if (!idType) {
      setError('ID Type is required');
      return;
    }
    if (!receiverName) {
      setError('Receiver Name is required');
      return;
    }
    if (!idNumber) {
      setError('ID Number is required');
      return;
    }
    // Validate ID number format based on type
    if (idType === 'CNIC' || idType === 'NICOP') {
      if (!/^\d{13}$/.test(idNumber)) {
        setError(`${idType} must be exactly 13 digits`);
        return;
      }
    } else if (idType === 'Passport') {
      if (!/^[A-Z0-9]{9}$/.test(idNumber.toUpperCase())) {
        setError('Passport number must be exactly 9 alphanumeric characters');
        return;
      }
    }
    // Validate contact number format: +92 followed by 10 digits
    if (!contactNumber) {
      setError('Contact number is required');
      return;
    }
    const contactRegex = /^\+92\d{10}$/;
    if (!contactRegex.test(contactNumber)) {
      setError('Contact number must be in format: +92XXXXXXXXXX (10 digits after +92)');
      return;
    }
    if (!country) {
      setError('Country is required');
      return;
    }
    if (!province) {
      setError('Province is required');
      return;
    }
    if (!city) {
      setError('City is required');
      return;
    }
    if (!idExpiry) {
      setError('ID Expiry Date is required');
      return;
    }
    // Validate ID expiry is in the future
    const expiryDate = new Date(idExpiry);
    const today = new Date();
    if (expiryDate <= today) {
      setError('ID Expiry Date must be in the future');
      return;
    }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Valid email is required');
      return;
    }
    if (!dateOfBirth) {
      setError('Date of Birth is required');
      return;
    }
    // Validate age is 18 or above
    if (!validateAge(dateOfBirth)) {
      setError('Age must be 18 years or above');
      return;
    }
    if (!zipCode) {
      setError('Zip Code is required');
      return;
    }
    // Validate zip code is exactly 5 digits
    if (!/^\d{5}$/.test(zipCode)) {
      setError('Zip Code must be exactly 5 digits');
      return;
    }
    if (!address) {
      setError('Address is required');
      return;
    }
    console.log('All validations passed'); // Debug log
    const transactionId = transaction?.id || `TXN${Date.now()}`;
    // Get user data from localStorage
    const user = localStorage.getItem('user');
    let userBranchCode = 'BR001';
    let isAgentUser = false;
    let userAgentCode = 'BIPL';
    if (user) {
      const userData = JSON.parse(user);
      userBranchCode = userData.branchCode || 'BR001';
      userAgentCode = userData.agentCode || 'BIPL';
      isAgentUser = userData.userType === 'agent' || userData.isAgent === true;
    }
    const finalBranchCode = userBranchCode;
    const finalAgentCode = isAgentUser ? userAgentCode : 'BIPL';
    // Get existing transactions
    const existingTransactions = JSON.parse(localStorage.getItem('initiatedTransactions') || '[]');
    setInitiatedTransactionId(transactionId);
    // Define original statuses for demo transactions
    const demoTransactionStatuses: {
      [key: string]: string;
    } = {
      '801234567': 'Pending Checker Approval',
      TXN000001201921: 'Pending Checker Approval',
      TXN000002225463: 'Pending Checker Approval',
      TXN000002225479: 'Pending Checker Approval',
      TXN000009658123: 'Pending Checker Approval',
      TXN000004478520: 'Pending Checker Approval'
    };
    const demoSanctionsStatuses: {
      [key: string]: string;
    } = {
      '801234567': 'Passed',
      TXN000001201921: 'Passed',
      TXN000002225463: 'Failed',
      TXN000002225479: 'Pending',
      TXN000009658123: 'Passed',
      TXN000004478520: 'Passed'
    };
    const transactionStatus = demoTransactionStatuses[transactionId] || 'Pending Checker Approval';
    const sanctionsStatus = demoSanctionsStatuses[transactionId] || 'Passed';
    // Determine MTO from sender country - derive from transaction data
    const getMtoFromCountry = (country: string): string => {
      const mtoMap: {
        [key: string]: string;
      } = {
        'United Arab Emirates': 'UAE Exchange',
        'United Kingdom': 'Western Union',
        'United States': 'MoneyGram',
        Canada: 'Ria Money Transfer',
        'Saudi Arabia': 'Al Ansari Exchange'
      };
      return mtoMap[country] || 'UAE Exchange';
    };
    const derivedMto = getMtoFromCountry(transaction?.sender.country || '');
    // Store the complete transaction with new ID verification fields
    const initiatedTransaction = {
      id: transactionId,
      status: transactionStatus,
      sanctionsCheck: sanctionsStatus,
      overview: {
        transactionId: transactionId,
        date: new Date().toISOString().split('T')[0],
        amount: transaction?.transaction.sendAmount || 0,
        currency: transaction?.transaction.sendCurrency || 'USD',
        exchangeRate: transaction?.transaction.exchangeRate || 0,
        payoutAmount: transaction?.transaction.payoutAmount || 0,
        payoutCurrency: transaction?.transaction.payoutCurrency || 'PKR',
        status: transactionStatus
      },
      parties: {
        sender: {
          name: transaction?.sender.fullName || 'Unknown',
          country: transaction?.sender.country || 'Unknown',
          city: transaction?.sender.city || 'Unknown',
          idType: transaction?.sender.idType || 'Unknown',
          idNumber: transaction?.sender.idNumber || 'Unknown',
          mobile: transaction?.sender.mobileNumber || 'Unknown'
        },
        receiver: {
          name: transaction?.receiver.fullName || 'Unknown',
          country: transaction?.receiver.country || 'Pakistan',
          city: transaction?.receiver.city || 'Unknown',
          mobile: transaction?.receiver.mobileNumber || 'Unknown'
        }
      },
      accounts: {
        bankName: transaction?.receiver.bankName || 'Unknown',
        bankBranch: transaction?.receiver.bankBranch || 'Unknown',
        accountNumber: transaction?.receiver.accountNumber || 'Unknown',
        accountTitle: transaction?.receiver.fullName || 'Unknown'
      },
      amounts: {
        sendAmount: transaction?.transaction.sendAmount || 0,
        sendCurrency: transaction?.transaction.sendCurrency || 'USD',
        exchangeRate: transaction?.transaction.exchangeRate || 0,
        fees: 0,
        payoutAmount: transaction?.transaction.payoutAmount || 0,
        payoutCurrency: transaction?.transaction.payoutCurrency || 'PKR'
      },
      compliance: {
        sanctionsCheck: sanctionsStatus,
        amlStatus: sanctionsStatus === 'Failed' ? 'Failed' : 'Clear',
        kycStatus: 'Verified',
        riskLevel: sanctionsStatus === 'Failed' ? 'High' : 'Low'
      },
      timeline: [{
        title: 'Transaction Initiated',
        description: 'Transaction created by teller',
        timestamp: new Date().toLocaleString(),
        status: 'completed'
      }, {
        title: 'Compliance Check',
        description: 'Sanctions and AML verification completed',
        timestamp: new Date().toLocaleString(),
        status: 'completed'
      }, {
        title: 'Payment Processing',
        description: 'Awaiting checker approval',
        timestamp: 'Pending',
        status: 'current'
      }, {
        title: 'Transaction Complete',
        description: 'Funds delivered to receiver',
        timestamp: 'Pending',
        status: 'pending'
      }],
      senderName: transaction?.sender.fullName || 'Unknown',
      receiverName: transaction?.receiver.fullName || 'Unknown',
      amount: transaction?.transaction.sendAmount || 0,
      currency: transaction?.transaction.sendCurrency || 'USD',
      payoutAmount: transaction?.transaction.payoutAmount || 0,
      payoutCurrency: transaction?.transaction.payoutCurrency || 'PKR',
      date: new Date().toISOString().split('T')[0],
      paymentMethod: '',
      country: transaction?.sender.country || 'Unknown',
      agent: derivedMto,
      mto: derivedMto,
      type: 'OTC',
      branchCode: finalBranchCode,
      agentCode: finalAgentCode,
      // New comprehensive ID verification fields
      idType: idType,
      idNumber: idNumber,
      veresysBioSys: veresysBioSys,
      ofacUnscVerification: ofacUnscVerification,
      contactNumber: contactNumber,
      receiverCountry: country,
      province: province,
      city: city,
      idExpiry: idExpiry,
      email: email,
      dateOfBirth: dateOfBirth,
      zipCode: zipCode,
      address: address,
      timestamp: new Date().toISOString(),
      createdAt: new Date().toISOString()
    };
    console.log('Saving transaction:', initiatedTransaction); // Debug log
    existingTransactions.unshift(initiatedTransaction);
    localStorage.setItem('initiatedTransactions', JSON.stringify(existingTransactions));
    console.log('Transaction saved, dispatching event'); // Debug log
    window.dispatchEvent(new Event('transactionAdded'));
    setShowDetails(false);
    setShowSuccessDialog(true);
    // Reset form
    setSearchId('');
    setTransaction(null);
    setIdType('CNIC');
    setError('');
    console.log('Transaction initiation complete'); // Debug log
  };
  const handleViewHistory = () => {
    setShowSuccessDialog(false);
    navigate('/history');
  };
  return <Box sx={{
    p: 3,
    bgcolor: 'background.default',
    minHeight: '100vh'
  }} data-id="element-1736">
      <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      mb: 3
    }} data-id="element-1737">
        <Icon icon="lucide:search" width={28} height={28} color="#0052CC" data-id="element-1738" />
        <Typography variant="h4" sx={{
        fontWeight: 700,
        color: '#0052CC'
      }} data-id="element-1739">
          Transaction Lookup
        </Typography>
      </Box>
      <Alert severity="info" icon={<InfoIcon data-id="element-1741" />} sx={{
      mb: 3
    }} data-id="element-1740">
        <Typography variant="subtitle2" sx={{
        fontWeight: 600,
        mb: 1
      }} data-id="element-1742">
          Demo Transaction IDs:
        </Typography>
        <Box component="ul" sx={{
        m: 0,
        pl: 2
      }} data-id="element-1743">
          <li data-id="element-1744">
            <strong data-id="element-1745">801234567</strong> - Multiple MTOs (Ecobank & Access) - Test
            MTO selection
          </li>
          <li data-id="element-1746">
            TXN000001201921 - Pending transaction with Sanctions Check Passed
          </li>
          <li data-id="element-1747">
            TXN000002225463 - Pending transaction with Sanctions Check Failed
          </li>
          <li data-id="element-1748">
            TXN000002225479 - Pending transaction with Sanctions Check Pending
          </li>
          <li data-id="element-1749">TXN000009658123 - Already Paid transaction</li>
          <li data-id="element-1750">TXN000004478520 - In Process transaction</li>
        </Box>
      </Alert>
      <Paper elevation={0} sx={{
      p: 3,
      mb: 3,
      borderRadius: 3,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
    }} data-id="element-1751">
        <Typography variant="h6" sx={{
        mb: 2,
        fontWeight: 600
      }} data-id="element-1752">
          Search Transaction
        </Typography>
        <Grid container spacing={2} data-id="element-1753">
          <Grid item xs={12} data-id="element-1754">
            <TextField fullWidth label="Transaction ID / Transaction Code" value={searchId} onChange={e => setSearchId(e.target.value)} placeholder="Enter Transaction ID or Transaction Code" data-id="element-1755" />
          </Grid>
          <Grid item xs={12} data-id="element-1756">
            <Button variant="contained" onClick={handleSearch} fullWidth sx={{
            maxWidth: {
              md: 200
            }
          }} data-id="element-1757">
              Search
            </Button>
          </Grid>
        </Grid>
        {error && !showDetails && <Alert severity="error" sx={{
        mt: 2
      }} data-id="element-1758">
            {error}
          </Alert>}
      </Paper>
      <Dialog open={showDetails} onClose={() => setShowDetails(false)} maxWidth="lg" fullWidth data-id="element-1759">
        <DialogTitle data-id="element-1760">
          <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }} data-id="element-1761">
            <Typography variant="h6" data-id="element-1762">Transaction Details</Typography>
            <IconButton onClick={() => setShowDetails(false)} data-id="element-1763">
              <CloseIcon data-id="element-1764" />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent data-id="element-1765">
          {transaction && <Grid container spacing={3} sx={{
          mt: 0.5
        }} data-id="element-1766">
              {/* Sender Information */}
              <Grid item xs={12} data-id="element-1767">
                <Card elevation={0} sx={{
              background: '#FFFFFF',
              borderRadius: 2,
              border: '1px solid #E5E7EB',
              boxShadow: '0px 1px 2px rgba(0,0,0,0.05)'
            }} data-id="element-1768">
                  <CardContent sx={{
                p: 3
              }} data-id="element-1769">
                    <Typography variant="subtitle1" sx={{
                  fontWeight: 600,
                  mb: 3,
                  color: '#1F2937',
                  fontSize: '1.1rem'
                }} data-id="element-1770">
                      Sender Information
                    </Typography>
                    <Grid container spacing={2.5} data-id="element-1771">
                      <Grid item xs={12} sm={4} md={2} data-id="element-1772">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1773">
                          Full Name
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1774">
                          {transaction.sender.fullName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1775">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1776">
                          Country
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1777">
                          {transaction.sender.country}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1778">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1779">
                          City
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1780">
                          {transaction.sender.city}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1781">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1782">
                          ID Type
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1783">
                          {transaction.sender.idType}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1784">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1785">
                          ID Number
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1786">
                          {transaction.sender.idNumber}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1787">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1788">
                          Mobile Number
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1789">
                          {transaction.sender.mobileNumber}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* Receiver Information */}
              <Grid item xs={12} data-id="element-1790">
                <Card elevation={0} sx={{
              background: '#FFFFFF',
              borderRadius: 2,
              border: '1px solid #E5E7EB',
              boxShadow: '0px 1px 2px rgba(0,0,0,0.05)'
            }} data-id="element-1791">
                  <CardContent sx={{
                p: 3
              }} data-id="element-1792">
                    <Typography variant="subtitle1" sx={{
                  fontWeight: 600,
                  mb: 3,
                  color: '#1F2937',
                  fontSize: '1.1rem'
                }} data-id="element-1793">
                      Receiver Information
                    </Typography>
                    <Grid container spacing={2.5} data-id="element-1794">
                      <Grid item xs={12} sm={4} md={2} data-id="element-1795">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1796">
                          Full Name
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1797">
                          {transaction.receiver.fullName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1798">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1799">
                          Country
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1800">
                          {transaction.receiver.country}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1801">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1802">
                          City
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1803">
                          {transaction.receiver.city}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1804">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1805">
                          Mobile Number
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1806">
                          {transaction.receiver.mobileNumber}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1807">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1808">
                          Bank Name
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1809">
                          {transaction.receiver.bankName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1810">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1811">
                          Bank Branch
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1812">
                          {transaction.receiver.bankBranch}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} data-id="element-1813">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1814">
                          Account Number / IBAN
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1815">
                          {transaction.receiver.accountNumber}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* Transaction Details */}
              <Grid item xs={12} data-id="element-1816">
                <Card elevation={0} sx={{
              background: '#FFFFFF',
              borderRadius: 2,
              border: '1px solid #E5E7EB',
              boxShadow: '0px 1px 2px rgba(0,0,0,0.05)'
            }} data-id="element-1817">
                  <CardContent sx={{
                p: 3
              }} data-id="element-1818">
                    <Typography variant="subtitle1" sx={{
                  fontWeight: 600,
                  mb: 3,
                  color: '#1F2937',
                  fontSize: '1.1rem'
                }} data-id="element-1819">
                      Transaction Details
                    </Typography>
                    <Grid container spacing={2.5} data-id="element-1820">
                      <Grid item xs={12} sm={4} md={2} data-id="element-1821">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1822">
                          Transaction Date
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1823">
                          {transaction.transaction.date}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1824">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1825">
                          Send Amount
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1826">
                          {transaction.transaction.sendAmount.toLocaleString()}{' '}
                          {transaction.transaction.sendCurrency}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1827">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1828">
                          Exchange Rate
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1829">
                          {transaction.transaction.exchangeRate}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1830">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1831">
                          Payout Amount
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1832">
                          {transaction.transaction.payoutAmount.toLocaleString()}{' '}
                          {transaction.transaction.payoutCurrency}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1833">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1834">
                          Purpose
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1835">
                          {transaction.transaction.purpose}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1836">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1837">
                          Relationship
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1838">
                          {transaction.transaction.relationship}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* Additional Information */}
              <Grid item xs={12} data-id="element-1839">
                <Card elevation={0} sx={{
              background: '#FFFFFF',
              borderRadius: 2,
              border: '1px solid #E5E7EB',
              boxShadow: '0px 1px 2px rgba(0,0,0,0.05)'
            }} data-id="element-1840">
                  <CardContent sx={{
                p: 3
              }} data-id="element-1841">
                    <Typography variant="subtitle1" sx={{
                  fontWeight: 600,
                  mb: 3,
                  color: '#1F2937',
                  fontSize: '1.1rem'
                }} data-id="element-1842">
                      Additional Information
                    </Typography>
                    <Grid container spacing={2.5} data-id="element-1843">
                      <Grid item xs={12} sm={4} md={2} data-id="element-1844">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1845">
                          Teller Information
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1846">
                          {transaction.teller.branchCode} -{' '}
                          {transaction.teller.branchName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1847">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1848">
                          Payment Date
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1849">
                          {transaction.teller.paymentDate}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1850">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1851">
                          Teller ID
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1852">
                          {transaction.teller.tellerId}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} data-id="element-1853">
                        <Typography variant="caption" color="text.secondary" sx={{
                      display: 'block',
                      mb: 0.5,
                      fontSize: '11px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }} data-id="element-1854">
                          Teller Name
                        </Typography>
                        <Typography variant="body2" sx={{
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#1F2937'
                    }} data-id="element-1855">
                          {transaction.teller.tellerName}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* ID Verification Form */}
              <Grid item xs={12} data-id="element-1856">
                <Card elevation={0} sx={{
              background: '#FFFFFF',
              borderRadius: 2,
              border: '1px solid #E5E7EB',
              boxShadow: '0px 1px 2px rgba(0,0,0,0.05)'
            }} data-id="element-1857">
                  <CardContent sx={{
                p: 3
              }} data-id="element-1858">
                    <Typography variant="subtitle1" sx={{
                  fontWeight: 600,
                  mb: 3,
                  color: '#1F2937',
                  fontSize: '1.1rem'
                }} data-id="element-1859">
                      ID Verification
                    </Typography>
                    {error && <Alert severity="error" sx={{
                  mb: 2
                }} data-id="element-1860">
                        {error}
                      </Alert>}
                    <Grid container spacing={2} alignItems="center" data-id="element-1861">
                      {/* Row 1: ID Type, Receiver Name, ID Number, Checkboxes */}
                      <Grid item xs={6} sm={3} md={2} data-id="element-1862">
                        <FormControl fullWidth size="small" required data-id="element-1863">
                          <InputLabel data-id="element-1864">ID Type</InputLabel>
                          <Select value={idType} label="ID Type" onChange={e => {
                        setIdType(e.target.value);
                        setIdNumber('');
                      }} data-id="element-1865">
                            <MenuItem value="CNIC" data-id="element-1866">CNIC</MenuItem>
                            <MenuItem value="NICOP" data-id="element-1867">NICOP</MenuItem>
                            <MenuItem value="Passport" data-id="element-1868">Passport</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6} sm={3} md={2.5} data-id="element-1869">
                        <TextField fullWidth required label="Receiver Name" value={receiverName} onChange={e => setReceiverName(e.target.value)} size="small" data-id="element-1870" />
                      </Grid>
                      <Grid item xs={6} sm={3} md={2.5} data-id="element-1871">
                        <TextField fullWidth required label="ID Number" value={idNumber} onChange={e => {
                      const value = e.target.value;
                      if (idType === 'Passport') {
                        setIdNumber(value.toUpperCase());
                      } else {
                        setIdNumber(value.replace(/\D/g, ''));
                      }
                    }} helperText={idType === 'Passport' ? '9 alphanumeric characters' : '13 digits'} size="small" inputProps={{
                      maxLength: idType === 'Passport' ? 9 : 13
                    }} data-id="element-1872" />
                      </Grid>
                      <Grid item xs={12} sm={3} md={5} data-id="element-1873">
                        <Box sx={{
                      display: 'flex',
                      gap: 2,
                      flexWrap: 'wrap',
                      alignItems: 'center'
                    }} data-id="element-1874">
                          <FormControlLabel control={<Checkbox checked={veresysBioSys} onChange={e => setVeresysBioSys(e.target.checked)} size="small" data-id="element-1876" />} label={<Typography variant="body2" data-id="element-1877">
                                Veresys (Bio-Sys)
                              </Typography>} data-id="element-1875" />
                          <FormControlLabel control={<Checkbox checked={ofacUnscVerification} onChange={e => setOfacUnscVerification(e.target.checked)} size="small" data-id="element-1879" />} label={<Typography variant="body2" data-id="element-1880">
                                OFAC/UNSC Verification
                              </Typography>} data-id="element-1878" />
                        </Box>
                      </Grid>

                      {/* Row 2: Contact Number, Country, Province, City */}
                      <Grid item xs={6} sm={3} md={3} data-id="element-1881">
                        <TextField fullWidth required label="Contact Number" value={contactNumber} onChange={e => {
                      const value = e.target.value;
                      if (value.startsWith('+92')) {
                        setContactNumber(value.slice(0, 13));
                      } else if (value === '+' || value === '+9') {
                        setContactNumber(value);
                      } else if (!value.startsWith('+92') && value.length > 0) {
                        setContactNumber('+92');
                      } else {
                        setContactNumber(value);
                      }
                    }} placeholder="+92XXXXXXXXXX" helperText="+92 followed by 10 digits" size="small" data-id="element-1882" />
                      </Grid>
                      <Grid item xs={6} sm={3} md={3} data-id="element-1883">
                        <TextField fullWidth disabled label="Country" value={country} size="small" helperText="Pakistan only" data-id="element-1884" />
                      </Grid>
                      <Grid item xs={6} sm={3} md={3} data-id="element-1885">
                        <FormControl fullWidth size="small" required data-id="element-1886">
                          <InputLabel data-id="element-1887">Province</InputLabel>
                          <Select value={province} label="Province" onChange={e => {
                        setProvince(e.target.value);
                        setCity('');
                      }} data-id="element-1888">
                            {provinces.map(p => <MenuItem key={p} value={p} data-id="element-1889">
                                {p}
                              </MenuItem>)}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6} sm={3} md={3} data-id="element-1890">
                        <FormControl fullWidth size="small" required disabled={!province} data-id="element-1891">
                          <InputLabel data-id="element-1892">City</InputLabel>
                          <Select value={city} label="City" onChange={e => setCity(e.target.value)} data-id="element-1893">
                            {province && citiesByProvince[province]?.map(c => <MenuItem key={c} value={c} data-id="element-1894">
                                  {c}
                                </MenuItem>)}
                          </Select>
                        </FormControl>
                      </Grid>

                      {/* Row 3: ID Expiry, Email */}
                      <Grid item xs={6} sm={3} md={3} data-id="element-1895">
                        <TextField fullWidth required label="ID Expiry Date" type="date" value={idExpiry} onChange={e => setIdExpiry(e.target.value)} InputLabelProps={{
                      shrink: true
                    }} inputProps={{
                      min: new Date().toISOString().split('T')[0]
                    }} helperText="Must be a future date" size="small" data-id="element-1896" />
                      </Grid>
                      <Grid item xs={6} sm={3} md={3} data-id="element-1897">
                        <TextField fullWidth required label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} size="small" data-id="element-1898" />
                      </Grid>

                      {/* Row 4: DOB, Zip Code, Address */}
                      <Grid item xs={6} sm={3} md={3} data-id="element-1899">
                        <TextField fullWidth required label="Date of Birth" type="date" value={dateOfBirth} onChange={e => setDateOfBirth(e.target.value)} InputLabelProps={{
                      shrink: true
                    }} inputProps={{
                      max: new Date().toISOString().split('T')[0]
                    }} helperText="Must be 18 years or older" size="small" data-id="element-1900" />
                      </Grid>
                      <Grid item xs={6} sm={3} md={3} data-id="element-1901">
                        <TextField fullWidth required label="Zip Code" value={zipCode} onChange={e => {
                      const value = e.target.value.replace(/\D/g, '');
                      setZipCode(value.slice(0, 5));
                    }} helperText="5 digits" size="small" inputProps={{
                      maxLength: 5
                    }} data-id="element-1902" />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} data-id="element-1903">
                        <TextField fullWidth required label="Address" value={address} onChange={e => setAddress(e.target.value)} size="small" data-id="element-1904" />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>}
        </DialogContent>
        <DialogActions sx={{
        p: 3,
        borderTop: '1px solid #E5E7EB'
      }} data-id="element-1905">
          <Button onClick={() => setShowDetails(false)} sx={{
          color: '#6B7280'
        }} data-id="element-1906">
            Cancel
          </Button>
          <Button variant="contained" onClick={handleInitiateTransaction} sx={{
          bgcolor: '#0052CC',
          '&:hover': {
            bgcolor: '#003DA8'
          }
        }} data-id="element-1907">
            Initiate Transaction
          </Button>
        </DialogActions>
      </Dialog>
      {/* MTO Selection Dialog */}
      <Dialog open={showMTOSelection} onClose={() => setShowMTOSelection(false)} maxWidth="md" fullWidth data-id="element-1908">
        <DialogTitle data-id="element-1909">
          <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }} data-id="element-1910">
            <Typography variant="h6" data-id="element-1911">Select MTO</Typography>
            <IconButton onClick={() => setShowMTOSelection(false)} data-id="element-1912">
              <CloseIcon data-id="element-1913" />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent data-id="element-1914">
          <Alert severity="info" sx={{
          mb: 3
        }} data-id="element-1915">
            Multiple transactions found with ID: <strong data-id="element-1916">{searchId}</strong>
            <br data-id="element-1917" />
            Please select the correct MTO to proceed.
          </Alert>

          <List data-id="element-1918">
            {matchingTransactions.map((txn, index) => <Fragment key={index} data-id="element-1919">
                <ListItem disablePadding data-id="element-1920">
                  <ListItemButton onClick={() => handleMTOSelection(txn)} sx={{
                borderRadius: 2,
                mb: 1,
                border: '1px solid',
                borderColor: 'divider',
                '&:hover': {
                  borderColor: 'primary.main',
                  bgcolor: 'primary.50'
                }
              }} data-id="element-1921">
                    <ListItemText primary={<Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2
                }} data-id="element-1923">
                          <Typography variant="h6" color="primary" data-id="element-1924">
                            {txn.mto}
                          </Typography>
                          <ChevronRightIcon data-id="element-1925" />
                        </Box>} secondary={<Box sx={{
                  mt: 1
                }} data-id="element-1926">
                          <Typography variant="body2" color="text.secondary" data-id="element-1927">
                            <strong data-id="element-1928">Sender:</strong> {txn.sender.fullName} (
                            {txn.sender.country})
                          </Typography>
                          <Typography variant="body2" color="text.secondary" data-id="element-1929">
                            <strong data-id="element-1930">Receiver:</strong> {txn.receiver.fullName} (
                            {txn.receiver.city})
                          </Typography>
                          <Typography variant="body2" color="text.secondary" data-id="element-1931">
                            <strong data-id="element-1932">Amount:</strong>{' '}
                            {txn.transaction.sendAmount.toLocaleString()}{' '}
                            {txn.transaction.sendCurrency} →{' '}
                            {txn.transaction.payoutAmount.toLocaleString()}{' '}
                            {txn.transaction.payoutCurrency}
                          </Typography>
                        </Box>} data-id="element-1922" />
                  </ListItemButton>
                </ListItem>
                {index < matchingTransactions.length - 1 && <Divider sx={{
              my: 1
            }} data-id="element-1933" />}
              </Fragment>)}
          </List>
        </DialogContent>
        <DialogActions data-id="element-1934">
          <Button onClick={() => setShowMTOSelection(false)} data-id="element-1935">Cancel</Button>
        </DialogActions>
      </Dialog>
      {/* Duplicate Transaction Dialog */}
      <Dialog open={showDuplicateDialog} onClose={() => setShowDuplicateDialog(false)} maxWidth="sm" fullWidth data-id="element-1936">
        <DialogTitle data-id="element-1937">
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2
        }} data-id="element-1938">
            <ErrorIcon color="error" sx={{
            fontSize: 40
          }} data-id="element-1939" />
            <Typography variant="h6" data-id="element-1940">Duplicate Transaction</Typography>
          </Box>
        </DialogTitle>
        <DialogContent data-id="element-1941">
          <Alert severity="error" sx={{
          mb: 2
        }} data-id="element-1942">
            Transaction {initiatedTransactionId} already exists in the system.
          </Alert>
          <Typography variant="body2" color="text.secondary" data-id="element-1943">
            This transaction ID has already been initiated. Please check the
            Transaction History page to view the existing transaction, or use a
            different transaction ID.
          </Typography>
        </DialogContent>
        <DialogActions data-id="element-1944">
          <Button onClick={() => setShowDuplicateDialog(false)} data-id="element-1945">Close</Button>
          <Button variant="contained" onClick={handleViewHistory} data-id="element-1946">
            View Transaction History
          </Button>
        </DialogActions>
      </Dialog>
      {/* Success Dialog */}
      <Dialog open={showSuccessDialog} onClose={() => setShowSuccessDialog(false)} maxWidth="sm" fullWidth data-id="element-1947">
        <DialogTitle data-id="element-1948">
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2
        }} data-id="element-1949">
            <CheckCircleIcon color="success" sx={{
            fontSize: 40
          }} data-id="element-1950" />
            <Typography variant="h6" data-id="element-1951">
              Transaction Initiated Successfully
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent data-id="element-1952">
          <Alert severity="success" sx={{
          mb: 2
        }} data-id="element-1953">
            Transaction {initiatedTransactionId} has been initiated and is now
            pending approval.
          </Alert>
          <Typography variant="body2" color="text.secondary" data-id="element-1954">
            You can view this transaction in the Transaction History page. The
            transaction will be processed once approved by a checker.
          </Typography>
        </DialogContent>
        <DialogActions data-id="element-1955">
          <Button onClick={() => setShowSuccessDialog(false)} data-id="element-1956">Close</Button>
          <Button variant="contained" onClick={handleViewHistory} data-id="element-1957">
            View Transaction History
          </Button>
        </DialogActions>
      </Dialog>
    </Box>;
};
export default TransactionLookupPage;